import React from 'react';
import { ChangeEvent } from 'react';
import { connect } from 'react-redux';
import { IDispatchProp } from 'restdux';
import { 
  Card,
  CardContent,
  Fab,
  FormControl,
  InputLabel,
  List,
  MenuItem,
  Select,
  TextField,
  Theme,
  withTheme, 
  WithTheme 
} from '@material-ui/core';
import { createStyles, withStyles, WithStyles } from '@material-ui/styles';
import { Add as AddIcon, NavigateNext } from '@material-ui/icons';
import '../../styles/App.css';
import MainLayout from '../../components/MainLayout';
import LoadIndicator from '../../components/LoadIndicator';
import RoleGate from '../../components/RoleGate';
import UserItem from '../../components/user/Item';
import UserAddModal from '../../components/user/AddEditModal';
import { actions as userActions, IReturn as User } from '../../api/resources/User';
import { ApplicationState } from '../../reducers';

const styles = (theme: Theme) =>
    createStyles({
        fab: {
          position: 'fixed',
          bottom: theme.spacing(2),
          right: theme.spacing(2),
        },      
        searchBar: {
          display: 'flex',
          justifyContent: 'space-between',
          margin: '16px 0',
        },
        filterBox: {
          minWidth: 120,
        },
        filler: {
          display: 'flex',
          flex: 1
        }
    });

interface IProps {
  users: User[];
}

const mapStateToProps = (state: ApplicationState) => {
  return {
    users: Object.values(state.user.data),
  };
}


type FullProps = IProps & WithStyles<typeof styles> & WithTheme & IDispatchProp;
class Users extends React.PureComponent<FullProps> {
  state = {
    isLoading: false,
    filter: 'all',
    search: '',
    showAddModal: false,
  }
  
  componentDidMount() {
    this.retrieveData();
  }

  public async retrieveData() {
    const { dispatch } = this.props;
    const { search } = this.state;
    if (search) {
      dispatch(userActions.index(undefined, undefined, {search}));
    }
    else {
      dispatch(userActions.index(undefined, undefined, {}));
    }
  }
  
  render() {
    const { classes, users } = this.props;
    const { isLoading, filter, search, showAddModal } = this.state;

    const usersMarkup = users
      .filter((user) => !search || user.email.toLowerCase().indexOf(search.toLowerCase()) >= 0)
      .map((user, index) => {
        return (
          <UserItem index={index} user={user} key={index} />
        )
      });
    
    return (
      <MainLayout title='Manage Users'>
          <RoleGate role='admin' />
          {isLoading ? (
            <LoadIndicator />
          ) : (
            <>
              <div className={classes.searchBar}>
                <div className={classes.filler} />
                <TextField label="Search" variant="filled" onChange={(evt) => this.setState({search:evt.target.value})} />
                {/* <FormControl variant="filled" className={classes.filterBox}>
                  <InputLabel id="filter-label">Filter</InputLabel>
                  <Select
                    labelId="filter-label"
                    value={filter}
                    onChange={this.handleFilterChange}
                  >
                    <MenuItem value={'all'}><em>None</em></MenuItem>
                    <MenuItem value={'active'}>Active</MenuItem>
                  </Select>
                </FormControl> */}
              </div>
              <Card>            
                <CardContent>
                  <List>
                    { usersMarkup }                
                  </List>
                </CardContent>
              </Card>
            </>
          )}
          <Fab color="primary" aria-label="add" className={classes.fab} onClick={this.handleAddClick}>
            <AddIcon />
          </Fab>
          <UserAddModal open={showAddModal} onDismiss={this.handleDismiss} />
      </MainLayout>
    );
  }

  private handleFilterChange = (event: ChangeEvent<{name?: string, value: unknown}>) => {
    this.setState({filter: event.target.value});
  }

  private handleAddClick = () => {
    this.setState({showAddModal: true});
  }

  private handleDismiss = (shouldRefresh: boolean) => {
    this.setState({showAddModal: false});
  }
}

export default connect(mapStateToProps)(withTheme(withStyles(styles)(Users)));